/**
 * Surface driver compliance warnings returned from leg assignment APIs.
 *
 * @param {Array<{code?:string,message?:string}>} warnings
 * @param {{toast:Function}} helpers
 */
export function showDriverComplianceWarnings(warnings = [], { toast }) {
  if (!warnings?.length || !toast) return;

  warnings.forEach((warning, index) => {
    if (!warning?.message) return;
    toast.warning(warning.message, {
      toastId: `driver-compliance-${warning.code || index}`,
      autoClose: 8000,
    });
  });
}

/**
 * Extract compliance warnings from leg create/update API envelopes.
 *
 * @param {object} response
 * @returns {Array}
 */
export function getDriverComplianceWarningsFromResponse(response = {}) {
  return (
    response.driverComplianceWarnings ||
    response.data?.driverComplianceWarnings ||
    []
  );
}
